import _regeneratorRuntime from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalIconButton from '@/components/shared/ModalIconButton';
import LocationGroupSelect from '@/components/shared/LocationGroupSelect';
import Alert from '@/components/shared/Alert';
import { LocationAdministration, SurveyManagement, SurveyManagementOverview } from '@/services/ResourceService';
var Source = {
  TABLET: 'TABLET',
  TERMINAL: 'TERMINAL',
  WEB: 'WEB'
};
export default {
  name: 'SurveyManagementAssignModal',
  props: {
    surveyId: {
      type: Number,
      required: true
    },
    surveyName: {
      type: String,
      required: true
    }
  },
  components: {
    ModalIconButton: ModalIconButton,
    Alert: Alert,
    LocationGroupSelect: LocationGroupSelect
  },
  data: function data() {
    return {
      isLoading: false,
      isErrorOccurred: false,
      locations: [],
      selectedLocations: [],
      removedItems: {
        locations: [],
        sources: []
      }
    };
  },
  computed: {
    originalLocations: function originalLocations() {
      var _this = this;
      return this.locations.filter(function (location) {
        return location.surveyId === _this.surveyId;
      });
    },
    preSelectedIds: function preSelectedIds() {
      return {
        locations: this.originalLocations.map(function (location) {
          return location.id;
        })
      };
    },
    removedTabletsWithName: function removedTabletsWithName() {
      return this.removedItems.sources.filter(function (source) {
        return source.type === Source.TABLET && source.name;
      });
    },
    removedTabletsWithoutName: function removedTabletsWithoutName() {
      return this.removedItems.sources.filter(function (source) {
        return source.type === Source.TABLET && !source.name;
      });
    },
    removedWebsWithName: function removedWebsWithName() {
      return this.removedItems.sources.filter(function (source) {
        return source.type === Source.WEB && source.name;
      });
    },
    removedWebsWithoutName: function removedWebsWithoutName() {
      return this.removedItems.sources.filter(function (source) {
        return source.type === Source.WEB && !source.name;
      });
    },
    removedTerminalsWithName: function removedTerminalsWithName() {
      return this.removedItems.sources.filter(function (source) {
        return source.type === Source.TERMINAL && source.name;
      });
    },
    removedTerminalsWithoutName: function removedTerminalsWithoutName() {
      return this.removedItems.sources.filter(function (source) {
        return source.type === Source.TERMINAL && !source.name;
      });
    }
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this2 = this;
      this.isLoading = true;
      this.isErrorOccurred = false;
      var companyId = this.$store.state.general.companyId;
      LocationAdministration.getActiveLocations(companyId).then(function (response) {
        _this2.locations = response.data;
        _this2.selectedLocations = _this2.locations.filter(function (location) {
          return location.surveyId === _this2.surveyId;
        });
        _this2.isLoading = false;
      }, function () {
        _this2.isLoading = false;
        _this2.isErrorOccurred = true;
      });
    },
    cancel: function cancel() {
      this.$vuedals.close();
    },
    submit: function submit() {
      var _this3 = this;
      this.isLoading = true;
      this.isErrorOccurred = false;
      var companyId = this.$store.state.general.companyId;
      SurveyManagementOverview.assignSurvey(companyId, this.surveyId, this.selectedLocations.map(function (location) {
        return location.id;
      })).then(function () {
        _this3.isLoading = false;
        _this3.$vuedals.close({
          okay: true
        });
      }, function () {
        _this3.isLoading = false;
        _this3.isErrorOccurred = true;
      });
    },
    onChangeSurveyLocations: function onChangeSurveyLocations(payload) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var selectedLocationIds, sourceResponse;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this4.selectedLocations = _this4.locations.filter(function (location) {
                return payload.queryLocations.includes(location.id);
              });
              selectedLocationIds = _this4.selectedLocations.map(function (location) {
                return location.id;
              });
              _this4.removedItems.locations = _this4.originalLocations.filter(function (location) {
                return !selectedLocationIds.includes(location.id);
              });
              _context.next = 5;
              return SurveyManagement.getLocationSources(_this4.$store.state.general.companyId, _this4.removedItems.locations.map(function (location) {
                return location.id;
              }));
            case 5:
              sourceResponse = _context.sent;
              _this4.removedItems.sources = sourceResponse.data.reduce(function (accumulator, currentValue) {
                return accumulator = [].concat(_toConsumableArray(accumulator), _toConsumableArray(currentValue.sources));
              }, []);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};